export const setTab = tab => ({ type: 'SET_TAB', payload: tab });
export const setProfileTab = profileTab => ({
  type: 'SET_PROFILE_TAB',
  payload: profileTab
});
export const setTermsTab = termsTab => ({
  type: 'SET_TERMS_TAB',
  payload: termsTab
});
